import { apiClient } from "@dit/core-frontend"
import { API_ENDPOINTS } from "@src/constants"
import { $nodesOfType, createEditor } from "lexical"
import { $unwrapMarkNode, MarkNode } from "../nodes/MarkNode"

export const getAllTextBlockIds = async (pageId) => {
  try {
    const { data } = await apiClient.get(API_ENDPOINTS.textComments, {
      params: {
        pageId: pageId,
        epp: 1000,
      },
    })

    const commentsData = data.data.itemsList || []
    const textBlockIds = []
    commentsData.map((comment) => {
      textBlockIds.push(comment.textBlockId)
      return undefined
    })

    return textBlockIds
  } catch (err) {
    console.error(err)
  }
}

export const deleteEmptyMarkNodes = async (text, pageId, nodes) => {
  let isComments = false
  let state = ""
  const newEditor = createEditor({
    nodes: nodes,
    disableEvents: false,
    editable: true,
    onError: (err) => console.error(err),
  })
  newEditor.update(() => {
    const editorState = newEditor.parseEditorState(text)
    newEditor.setEditorState(editorState)
  })
  newEditor.update(
    () => {
      const markNodes = $nodesOfType(MarkNode)
      if (markNodes.length) {
        isComments = true
      }
    },
    { discrete: true, tag: "historic" },
  )
  if (isComments) {
    const textBlockIds = (await getAllTextBlockIds(pageId)) || []
    const textBlockIdsSet = new Set(textBlockIds)

    newEditor.update(
      () => {
        const markNodes = $nodesOfType(MarkNode)
        for (const markNode of markNodes) {
          if (!textBlockIdsSet.has(markNode.__id)) {
            $unwrapMarkNode(markNode)
          }
        }
      },
      { discrete: true, tag: "historic" },
    )
  }

  newEditor.update(() => {
    state = newEditor.toJSON().editorState
  })
  return state
}
